import useTranslation from '@/utils/hooks/translation/useTranslation';

import { ModalUpsell } from '@/components/composite/Modals/ModalUpsell';

type MentionsUpsellModalProps = {
    isOpen: boolean;
    toggle: () => void;
};

export const MentionsUpsellModal = ({ isOpen, toggle }: MentionsUpsellModalProps) => {
    const { t } = useTranslation('commons');

    if (!isOpen) return null;

    return (
        <ModalUpsell
            heading={t('upsell_modal.mentions.heading')}
            description={t('upsell_modal.mentions.description')}
            benefits={[
                { text: t('upsell_modal.mentions.benefit1'), icon: 'check' },
                { text: t('upsell_modal.mentions.benefit2'), icon: 'check' },
                { text: t('upsell_modal.mentions.benefit3'), icon: 'check' },
                { text: t('upsell_modal.mentions.benefit4'), icon: 'plus' }
            ]}
            illustrationPath="/images/modals/modalUpsell/mention.png"
            dismiss={toggle}
            icon="rocket-outline"
        />
    );
};
